module.exports = "https://web-assets.ifttt.com/packs/media/partners/down_arrow_sm-5f02a6ab.svg";